document.addEventListener('DOMContentLoaded', function () {
  const accordionHeaders = document.querySelectorAll('.faq-new-template__section .faq-section .yeti-accordion-wrap h3');

  accordionHeaders.forEach(header => {
    header.addEventListener('click', function () {
      const wrap = header.closest('.yeti-accordion-wrap');

      if (!wrap) return;

      if (wrap.classList.contains('active')) {
        wrap.classList.remove('active');
      } else {
        const allWraps = document.querySelectorAll('.yeti-accordion-wrap');
        allWraps.forEach(w => w.classList.remove('active'));

        wrap.classList.add('active');
      }
    });
  });
});